import React from "react";

const WelcomeCitySection = () => {
  return (
    <div className="text-center my-12 px-4">
      {/* Title */}
      <h1
        className="text-4xl md:text-5xl text-gray-800 italic mb-4"
        style={{ fontFamily: "Tiro Devanagari Hindi, serif" }}
      >
        Welcome to Prayagraj
      </h1>

      {/* Description */}
      <p className="text-gray-700 text-lg max-w-7xl mx-auto leading-relaxed">
        Prayagraj, formerly Allahabad, has been a city of learning, wisdom, and
        writing. It is one of India's most vibrant politically, spiritually
        conscious, and spiritually awakened cities. Prayagraj is among the
        largest cities in Uttar Pradesh and is situated at the confluence of
        three rivers: Ganga, Yamuna, and the invisible Saraswati. The meeting
        point is known as Triveni or Sangam. The city, better known as "Prayag,"
        has many governmental institutions, which include MNNIT Allahabad, High
        Court of Uttar Pradesh, Allahabad University, IIIT Allahabad, and
        tourist places like Sangam, Allahabad Fort, Anand Bhawan, Swaraj Bhawan,
        Narayani Ashram, Ashoka Pillar, Khusro Bagh etc. At this holy city of
        Prayagraj, we invite you to a "Sangam" of Immunology and Technology at
        the "Immunocon-2025" at MNNIT, Allahabad. Weather: During the end of
        November month, the city experiences mild warm days but cool nights. The
        temperature during the middle/end of November usually varies between
        20-28 0C. Therefore, delegates are advised to bring light woolen
        clothes. The weather conditions will be updated as we approach the
        conference. 
      </p>
    </div>
  );
};

export default WelcomeCitySection;
